{
  "kind": {
    "held": "Held deposits",
    "delivered": "Delivered deposits",
    "detailed": "Detailed statement",
    "by-customer": "By customer",
    "by-employee": "By employee"
  },
  "description": {
    "held": "The balance of deposits in our custody per currency. It is a record of deposits, not the branch cash box.",
    "delivered": "Delivered and returned deposits by delivery date.",
    "detailed": "Every deposit within the filters.",
    "by-customer": "Each customer's deposits as depositor or recipient.",
    "by-employee": "Deposits received, deliveries made and returns made per employee, each counted separately."
  },
  "any": "All",
  "customer": "Customer",
  "customerPlaceholder": "Customer name or phone",
  "employee": "Employee",
  "recipient": "Recipient",
  "depositDate": "Deposit date",
  "deliveryDate": "Delivery date",
  "totals": "Totals per currency",
  "heldTotals": "Held per currency",
  "heldNote": "Each currency has its own total; currencies are never added together.",
  "countLabel": "Count {{formatted}}",
  "asDepositor": "As depositor",
  "asRecipient": "As recipient",
  "depositsReceived": "Deposits received",
  "deliveriesMade": "Deliveries made",
  "returnsMade": "Returns",
  "exportPdf": "Export PDF"
}
